// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file entities/app/my_account/contact.proto (package protos.entities.app.my_account, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file entities/app/my_account/contact.proto.
 */
export const file_entities_app_my_account_contact: GenFile = /*@__PURE__*/
  fileDesc("CiVlbnRpdGllcy9hcHAvbXlfYWNjb3VudC9jb250YWN0LnByb3RvEh5wcm90b3MuZW50aXRpZXMuYXBwLm15X2FjY291bnQiPwoHQ29udGFjdBINCgVlbWFpbBgBIAEoCRIUCgxwaG9uZV9udW1iZXIYAiABKAkSDwoHd2Vic2l0ZRgDIAEoCWIGcHJvdG8z");

/**
 * @generated from message protos.entities.app.my_account.Contact
 */
export type Contact = Message<"protos.entities.app.my_account.Contact"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string phone_number = 2;
   */
  phoneNumber: string;

  /**
   * @generated from field: string website = 3;
   */
  website: string;
};

/**
 * Describes the message protos.entities.app.my_account.Contact.
 * Use `create(ContactSchema)` to create a new message.
 */
export const ContactSchema: GenMessage<Contact> = /*@__PURE__*/
  messageDesc(file_entities_app_my_account_contact, 0);

